// extracted by mini-css-extract-plugin
module.exports = {"componentContainer":"styles_componentContainer__1V2ic","container":"styles_container__39oCY","question":"styles_question__3pOmU","answer":"styles_answer__2y8xg","questionIcon":"styles_questionIcon__d7j4w"};
    if(module.hot) {
      // 1744789732272
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  